import { render, staticRenderFns } from "./TopBarPage.vue?vue&type=template&id=03581cb0&scoped=true"
import script from "./TopBarPage.vue?vue&type=script&lang=js"
export * from "./TopBarPage.vue?vue&type=script&lang=js"
import style0 from "./TopBarPage.vue?vue&type=style&index=0&id=03581cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03581cb0",
  null
  
)

export default component.exports